import {getTextByValue} from "../../../../Utilities/Types/listUtilities";
import {LOAN_LIBRARY_LOAN_STATUS_LIST} from "./loanLibraryLoanConstants";
import {updateLoanLibraryLoanItemModel} from "./loanLibraryLoanFactory";
import type { LoanLibraryLoanItem } from './loanLibraryLoan.types';

export const getLoanLibraryLoanStatusTextByValue = (value: string | number = "") => getTextByValue(LOAN_LIBRARY_LOAN_STATUS_LIST, value);

export async function copyToClipboard(textToCopy: string) {
    if (!navigator.clipboard) {
        alert("Copy not supported. Try again.");
        return;
    }
    try {
        await navigator.clipboard.writeText(textToCopy);
        setTimeout(() => alert("Address copied to clipboard."), 1000);
    } catch (err) {
        alert("Copy failed. Try again.");
    }
}

export function getChangedLoanLibraryLoanItemsForUpdate(loanLibraryLoanItems: LoanLibraryLoanItem[], originalLoanLibraryLoanItems: LoanLibraryLoanItem[]) {
    return loanLibraryLoanItems
        .filter((item: LoanLibraryLoanItem) => {
            const originalLoanLibraryLoanItem = originalLoanLibraryLoanItems.find((o: LoanLibraryLoanItem) => o.loanLibraryLoanId === item.loanLibraryLoanId);

            if (!originalLoanLibraryLoanItem) return false;

            const statusChanged = originalLoanLibraryLoanItem.loanLibraryLoanStatus !== item.loanLibraryLoanStatus;
            const notesChanged = (originalLoanLibraryLoanItem.loanLibraryLoanNotes || "") !== (item.loanLibraryLoanNotes || "");

            return statusChanged || notesChanged;
        })
        
        .map((item: LoanLibraryLoanItem) => updateLoanLibraryLoanItemModel({
            loanLibraryLoanId: item.loanLibraryLoanId,
            loanLibraryLoanStatus: item.loanLibraryLoanStatus,
            loanLibraryLoanNotes: item.loanLibraryLoanNotes,
            loanItemNotes: item.loanItemNotes,
        }));
}

